import React, { useState } from "react";
import { logOut } from "../../store/auth/authActions";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import AccountData from "./AccountData";
import ChangePassword from "./ChangePassword";
import { setInfoMessage } from "../../store/alerts/alertsActions";
import { MdMailOutline, MdOutlineInfo, MdOutlineSettings } from "react-icons/md";
import "./AccountData.scss";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import HtmlTooltip from "@mui/material/Tooltip";
import LoadingSpinner from "../../../features/Loading/LoadingSpinner";
import { useTranslation } from "react-i18next";
import UserDataValidator from "../UserDataValidator";

const AccountDataPanel: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userData = useSelector((state: State) => state.auth.userData);
  const loading = useSelector((state: State) => state.auth.loading);
  const [open, setOpen] = useState(false);

  const isDesktop = useDesktopSize();
  const notAvailable = () => {
    dispatch(setInfoMessage(["Ta operacja będzie dostępna wkrótce"]));
  };

  const newsLetterActive = useSelector((state: State) => state.config.configuration.newsLetterActive);

  return (
    <div className="account-data ">
      {loading ? (
        <div className="flex-between-center">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="padding-big box shadow flex-between-center border">
          <h2 className="italic">
            {t("czesc")}, {userData.firstName}
            {isDesktop && <React.Fragment> {userData.lastName}</React.Fragment>}
          </h2>

          <div className="buttons flex-end-center">
            {userData.allowMailing && (
              <HtmlTooltip
                placement="left"
                title={
                  <React.Fragment>
                    <article
                      className="alert-green alert"
                      dangerouslySetInnerHTML={{ __html: t("jestes_zapisany_do_newslettera") }}
                    ></article>
                  </React.Fragment>
                }
              >
                <div>
                  {" "}
                  <MdMailOutline className="big-icon move-up" />
                </div>
              </HtmlTooltip>
            )}

            <HtmlTooltip
              placement="left"
              title={
                <React.Fragment>
                  <article
                    className="alert-yellow alert"
                    dangerouslySetInnerHTML={{
                      __html: `${t(
                        "jak_korzystac_z_konta_internetowego"
                      )} <a href="https://eaktywni.pl/2022/01/27/internetowe-konto-klienta/">${t(
                        "kliknij_i_zobacz"
                      )}</a>`,
                    }}
                  ></article>
                </React.Fragment>
              }
            >
              <div>
                {" "}
                <MdOutlineInfo className="big-icon move-up" />
              </div>
            </HtmlTooltip>

            <MdOutlineSettings onClick={() => setOpen(!open)} className="big-icon-second move-up" />
          </div>

          {open && (
            <div className="drop-down big-shadow flex-column">
              <AccountData />
              <ChangePassword />

              {userData.allowMailing && (
                <React.Fragment>
                  <button
                    onClick={() => notAvailable()}
                    className="button medium padding-zero full-button button-text-gray"
                  >
                    {t("zrezygnuj_z_newslettera")}
                  </button>
                </React.Fragment>
              )}

              <button
                onClick={() => dispatch(logOut())}
                className="button medium padding-zero full-button button-text-gray"
              >
                {t("wyloguj_sie")}
              </button>
              <div className="line-down"></div>
              <button
                onClick={() => notAvailable()}
                className="button medium padding-zero full-button button-text-gray"
              >
                {t("usun_konto")}
              </button>
            </div>
          )}
        </div>
      )}

      <UserDataValidator />
    </div>
  );
};

export default AccountDataPanel;
